export const breadcrumb = {
  title: 'Database',

  database: {
    index: 'Daftar databases',
    import: 'Import',
    recipient: {
      create: 'Buat kontak',
      edit: 'Edit kontak'
    }
  },
  group: {
    index: 'Kelompok'
  }
};
